import { render, staticRenderFns } from "./giftExchange.vue?vue&type=template&id=4e5d5fa8&scoped=true&"
import script from "./giftExchange.vue?vue&type=script&lang=js&"
export * from "./giftExchange.vue?vue&type=script&lang=js&"
import style0 from "./giftExchange.vue?vue&type=style&index=0&id=4e5d5fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d5fa8",
  null
  
)

export default component.exports